import create from "zustand"

export const useModal = create((set) => ({
  modalJsx: <></>,
  showModal: false,
  openModal: (jsx) => set({ showModal: true, modalJsx: jsx }),
  closeModal: () => set({ showModal: false, modalJsx: <></> }),
}))
